import React, { useEffect, useState } from 'react';
import Header from "../../components/Header";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { MascaraCnpj } from '../../../utils/MascaraCnpj';
import { formatToBrl } from '../../../utils/FormatToBrl';

const DetalhesImportacao = () => {

    const navigate = useNavigate();
    const { idImportacao } = useParams();

    const [importacaoDetails, setImportacaoDetails] = useState([]);
    const [importacaoRealizada, setImportacaoRealizada] = useState(null);

    useEffect(() => {
        const getImportacaoDetails = async () => {
            if (idImportacao) {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const response = await axios.get(`${process.env.REACT_APP_API_URL}/detalhes/importacao/${idImportacao}`, {
                            headers: {
                                Authorization: token
                            }
                        });
                        setImportacaoDetails(response.data.importacao.detalhes);
                        setImportacaoRealizada(response.data.importacao);
                        console.log(response.data.importacao);
                    } catch (error) {
                        console.error('Erro ao buscar detalhes da importação:', error);
                    }
                }
            }
        }

        getImportacaoDetails();
    }, [idImportacao]);

    return (
        <div>
            <Header />
            <div style={{ width: '100%', height: '90vh', display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '90%', marginTop: 20 }}>
                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigate("../dashboard")}>
                                Dashboard
                            </Link>
                            <Link underline="hover" color="inherit" onClick={() => navigate("../obrigacoes")}>
                                Obrigações
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Detalhes da Importação</Typography>
                        </Breadcrumbs>
                    </div>
                    <div>
                        <h2>Detalhes da Importação</h2>
                    </div>
                    <div>
                        <h3>Importação #{idImportacao}, realizada em {importacaoRealizada?.criadoEm}</h3>
                    </div>

                    <div style={{ width: "100%", overflowX: "auto", marginTop: "20px" }}>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                borderRadius: "12px",
                                overflow: "hidden",
                                background: "#fff",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }}
                        >
                            <thead style={{ background: "#0b243d", color: "#fff" }}>
                                <tr>
                                    {["Cliente", "Processado", "Erros", "Competência", "Vencimento", "Valor", "Status"].map((header) => (
                                        <th
                                            key={header}
                                            style={{
                                                padding: "16px 18px",
                                                textAlign: "left",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                letterSpacing: "0.5px",
                                            }}
                                        >
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {importacaoDetails.map((importacao, i) => (
                                    <tr
                                        key={importacao?.competencia}
                                        style={{
                                            background: i % 2 === 0 ? "#f9f9f9" : "#fff",
                                            transition: "all 0.2s ease-in-out",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.background = "#eef3f8")}
                                        onMouseLeave={(e) =>
                                            (e.currentTarget.style.background = i % 2 === 0 ? "#f9f9f9" : "#fff")
                                        }
                                    >
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}><b>{MascaraCnpj(importacao?.cliente.cnpj || "00000000000000")}</b><br />{importacao?.cliente.razaoSocial}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px", fontWeight: 500, color: importacao?.erro === null ? "green" : "red" }}>{importacao?.erro === null ? "SIM" : "NÃO"}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px", color: importacao?.erro === null ? "green" : "red" }}>{importacao?.detalhesErro ? importacao?.detalhesErro : "---"}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}>{importacao?.competencia}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}>{importacao?.vencimento}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px", color: "green", fontWeight: "bold" }}>{formatToBrl(importacao?.valor)}</td>
                                        <td style={{ padding: "14px 18px", fontSize: "14px" }}><span style={{ color: importacao?.status === "PROCESSADO" ? "green" : "red", fontWeight: "bold", width: "120px", display: "inline-block", backgroundColor: importacao?.status === "PROCESSADO" ? "#d4edda" : "#f8d7da", textAlign: "center", lineHeight: "20px", borderRadius: "4px", padding: "6px" }}>{importacao?.status}</span></td>
                                        {/* <td style={{ padding: "14px 18px", fontSize: "14px" }}>Botao</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DetalhesImportacao;